import { render, staticRenderFns } from "./dialogEditItem.vue?vue&type=template&id=00b02404&scoped=true"
import script from "./dialogEditItem.vue?vue&type=script&lang=js"
export * from "./dialogEditItem.vue?vue&type=script&lang=js"
import style0 from "./dialogEditItem.vue?vue&type=style&index=0&id=00b02404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b02404",
  null
  
)

export default component.exports